/**
 * File share.js.
 *
 * share things, and calendar things.
 *
 * @package wildrivers
 */

export function share() {

    const shareLinks = document.querySelectorAll( '.share-links:not(.add-to-calendar-links)' ); 
    shareLinks?.forEach( (links) => {

        const toggleButton = links.querySelector('button');
        const shareMenu    = links.querySelector('div');

        function toggleShareLinks( e ) {
            if ( links.classList.contains( 'share-links--active' ) ){
                links.classList.remove( 'share-links--active' );
                shareMenu.setAttribute( 'aria-expanded', 'false' );
                toggleButton?.setAttribute( 'aria-expanded', 'false' );
            } else {
                links.classList.add( 'share-links--active' );
                shareMenu.setAttribute( 'aria-expanded', 'true' );
                toggleButton?.setAttribute( 'aria-expanded', 'true' );
            }
        }
        
        toggleButton.addEventListener( 'click', toggleShareLinks );

        // copy link to clipboard
        const copyLinkButton = links.querySelector('a.copy-link');
        function copyContent() {        
            const textToCopy  = copyLinkButton.getAttribute('data-clipboard-text');
            const textSuccess = copyLinkButton.querySelector( '.confirmation-text' );
            if ( ! textToCopy ) {
                console.log( 'no text copied' );
                return;
            }
            shareMenu.classList.add( 'overflow-visible' );
            textSuccess.classList.add('copy-text--show');
            navigator.clipboard.writeText( textToCopy );
            
            setTimeout( () => {
                textSuccess.classList.remove('copy-text--show');
            },
            1500);
            setTimeout( () => {
                shareMenu.classList.remove( 'overflow-visible' );
            },
            2000);
        }
        if ( copyLinkButton ) {
            copyLinkButton.addEventListener('keydown', (event) => {
                if (event.keyCode === 13) {
                    copyContent();
                }
            });
            copyLinkButton.addEventListener('click', () => {
                copyContent();
            });
        }

        // Close when clicking outside.
        document.addEventListener( 'click', ( e ) => {
            if ( ! links.classList.contains( 'share-links--active' ) ) return;
            if ( links.contains( e.target ) ) return;
            links.classList.remove( 'share-links--active' );
            shareMenu.setAttribute( 'aria-expanded', 'false' );
            toggleButton?.setAttribute( 'aria-expanded', 'false' );
        } );
    });
}
